import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "../App";
import About from "./About/About";

import NotFound from "./NotFound";
import "../css/index.css";
import {
  NavItem,
  ExternalNavLink,
  Container,
  WelcomeMessageContainer,
  WelcomeMessage,
  ExternalLinkContainer,
} from "./styles";

const Router = () => {
  return (
    <Container>
      <BrowserRouter>
        <WelcomeMessageContainer>
          <WelcomeMessage>Austin Burke</WelcomeMessage>
          <ExternalLinkContainer>
            <ExternalNavLink
              href="https://austinburkephotography.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Photography
            </ExternalNavLink>
          </ExternalLinkContainer>
        </WelcomeMessageContainer>
        <Switch>
          <Route exact path="/" component={App} />
          <Route exact path="/about" component={About} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    </Container>
  );
};

export default Router;
